import { FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth-context";
import { Logo } from "../components/Logo";
import { ThemeToggle } from "../theme-context";
import { useI18n } from "../i18n";

export default function LoginPage() {
  const { login } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      await login(email, password);
      nav("/", { replace: true });
    } catch (e: unknown) {
      setErr(e instanceof Error ? e.message : "Something went wrong");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-dvh flex flex-col items-center justify-center px-5 safe-top safe-bottom">
      <div className="fixed right-4 top-0 z-10 safe-top flex items-center gap-2 pt-3">
        <ThemeToggle compact />
      </div>
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center text-center mb-8">
          <Logo size={64} />
          <h1 className="px-heading text-2xl mt-4 font-bold">PX7 Training</h1>
          <p className="text-px-text-muted text-sm mt-1">Science that leads to Performance.</p>
        </div>

        <form onSubmit={onSubmit} className="px-card space-y-4">
          <div>
            <label className="px-label" htmlFor="email">{t("auth.email")}</label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              inputMode="email"
              required
              className="px-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <label className="px-label" htmlFor="password">{t("auth.password")}</label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              className="px-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {err ? <p className="text-sm text-red-300">{err}</p> : null}

          <button className="px-btn-primary w-full" disabled={busy}>
            {busy ? t("auth.signingIn") : t("auth.signIn")}
          </button>

          <p className="text-center text-xs text-px-text-muted pt-1">
            <Link to="/forgot" className="hover:text-px-text">{t("auth.forgot")}</Link>
          </p>
        </form>

        <p className="text-center text-xs text-px-text-muted mt-6">
          {t("auth.noAccount")} <Link to="/signup" className="text-px-green hover:underline">{t("auth.signUp")}</Link>.
        </p>
      </div>
    </div>
  );
}
